import React, { Component } from 'react'
import uniqueId from 'lodash/uniqueId'
import isEqual from 'lodash/isEqual'

function generateIframeName() {
  return `sidx-post-iframe-${uniqueId()}`
}

export default class PostIframe extends Component {

  iframeName = generateIframeName()

  componentDidMount() {
    this.submitForm()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src || !isEqual(nextProps.params, this.props.params)) {
      this.needsRefresh = true
    }
  }

  componentDidUpdate() {
    if (this.needsRefresh) {
      this.needsRefresh = false
      this.submitForm()
    }
  }

  submitForm() {
    const form = this.buildForm()
    document.body.appendChild(form)
    form.submit()
    form.remove()
  }

  buildForm() {
    const { src, params } = this.props

    const form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('action', src)
    form.setAttribute('target', this.iframeName)

    Object.keys(params).forEach(key => {
      const input = document.createElement('input')
      input.setAttribute('type', 'hidden')
      input.setAttribute('name', key)
      input.setAttribute('value', params[key])
      form.appendChild(input)
    })

    return form
  }

  render() {
    const { src, params, ...props } = this.props
    return (
      <iframe ref={el => this.iframe = el} {...props} name={this.iframeName} />
    )
  }

}


// WEBPACK FOOTER //
// client/components/util/PostIframe.js